import { MediaMatcher } from '@angular/cdk/layout';
import { RouterModule } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../environments/environment';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: [],
  styles: ['.hide-xs { display: none; } @media (min-width: 600px) { .hide-xs { display: initial; } }'],
  standalone: true,
  // Must stay Eager until every routed page is OnPush: this shell wraps the
  // router-outlet, and an OnPush shell blocks CD traversal into Eager pages.
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    AppHeaderComponent,
    AppSidebarComponent
  ]
})
export class FullComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  minisidebar!: boolean;
  sidebarOpened!: boolean;
  private _mobileQueryListener: () => void;
  public isDevelopment: boolean = !environment.production;

  @ViewChild('snav') sidenav!: MatSidenav;
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  toggleSidenav() {
    if (this.sidenav.opened == false) {
      localStorage.setItem('sidemenuOpen', 'true');
    } else {
      localStorage.setItem('sidemenuOpen', 'false');
    }
    this.sidenav.toggle();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (localStorage.getItem('sidemenuOpen') == 'false') {
        this.sidenav.close();
      }
    }, 0)
  }
}
